import { render } from "./TheFooterComponent.vue?vue&type=template&id=5cbb8b1b&scoped=true"
import script from "./TheFooterComponent.vue?vue&type=script&lang=js"
export * from "./TheFooterComponent.vue?vue&type=script&lang=js"

import "./TheFooterComponent.vue?vue&type=style&index=0&id=5cbb8b1b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cbb8b1b"]])

export default __exports__